export default function TestimoniosMenu({ idioma }) {
  return (
    <iframe
      src={
        idioma === 'es'
          ? 'https://docs.terramarbrandsusa.com/legales/Lineamientos_de_testimonios_ESP.pdf'
          : 'https://docs.terramarbrandsusa.com/legales/Lineamientos_de_testimonios_ING.pdf'
      }
      style={{ width: '100%', height: '100%' }}
      frameBorder='0'
      title='framelegales'
    />
  );
}
